/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Meow Mobile API
 * MeowStore 모바일 백엔드 API 명세
 * OpenAPI spec version: v1.0.0
 */
import type {
  ClaimNpay200,
  CompleteAd200,
  ForfeitReward200,
  PlayStart200,
  PlayStop2200,
  StartAd200,
  TimeNyangAdCompleteRequest,
  TimeNyangAdStartRequest,
  TimeNyangAdminReloadResponse,
  TimeNyangNpayClaimRequest,
  TimeNyangPlayStartRequest,
  TimeNyangPlayStop2Request,
  TimeNyangRewardForfeitRequest,
  TimeNyangStateResponse,
} from '.././model';

/**
 * @summary 타임냥 보상 포기 처리
 */
export type forfeitRewardResponse200 = {
  data: ForfeitReward200;
  status: 200;
};

export type forfeitRewardResponseSuccess = forfeitRewardResponse200 & {
  headers: Headers;
};
export type forfeitRewardResponse = forfeitRewardResponseSuccess;

export const getForfeitRewardUrl = () => {
  return `/time-nyang/rewards/forfeit`;
};

export const forfeitReward = async (
  timeNyangRewardForfeitRequest: TimeNyangRewardForfeitRequest,
  options?: RequestInit,
): Promise<forfeitRewardResponse> => {
  const res = await fetch(getForfeitRewardUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(timeNyangRewardForfeitRequest),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: forfeitRewardResponse['data'] = body ? JSON.parse(body) : {};
  return { data, status: res.status, headers: res.headers } as forfeitRewardResponse;
};

/**
 * @summary 타임냥 플레이 정지/판정(stop2, 암호화 페이로드)
 */
export type playStop2Response200 = {
  data: PlayStop2200;
  status: 200;
};

export type playStop2ResponseSuccess = playStop2Response200 & {
  headers: Headers;
};
export type playStop2Response = playStop2ResponseSuccess;

export const getPlayStop2Url = () => {
  return `/time-nyang/play/stop2`;
};

export const playStop2 = async (
  timeNyangPlayStop2Request: TimeNyangPlayStop2Request,
  options?: RequestInit,
): Promise<playStop2Response> => {
  const res = await fetch(getPlayStop2Url(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(timeNyangPlayStop2Request),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: playStop2Response['data'] = body ? JSON.parse(body) : {};
  return { data, status: res.status, headers: res.headers } as playStop2Response;
};

/**
 * @summary 타임냥 플레이 시작
 */
export type playStartResponse200 = {
  data: PlayStart200;
  status: 200;
};

export type playStartResponseSuccess = playStartResponse200 & {
  headers: Headers;
};
export type playStartResponse = playStartResponseSuccess;

export const getPlayStartUrl = () => {
  return `/time-nyang/play/start`;
};

export const playStart = async (
  timeNyangPlayStartRequest: TimeNyangPlayStartRequest,
  options?: RequestInit,
): Promise<playStartResponse> => {
  const res = await fetch(getPlayStartUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(timeNyangPlayStartRequest),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: playStartResponse['data'] = body ? JSON.parse(body) : {};
  return { data, status: res.status, headers: res.headers } as playStartResponse;
};

/**
 * @summary 타임냥 N Pay 교환 처리
 */
export type claimNpayResponse200 = {
  data: ClaimNpay200;
  status: 200;
};

export type claimNpayResponseSuccess = claimNpayResponse200 & {
  headers: Headers;
};
export type claimNpayResponse = claimNpayResponseSuccess;

export const getClaimNpayUrl = () => {
  return `/time-nyang/npay/claim`;
};

export const claimNpay = async (
  timeNyangNpayClaimRequest: TimeNyangNpayClaimRequest,
  options?: RequestInit,
): Promise<claimNpayResponse> => {
  const res = await fetch(getClaimNpayUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(timeNyangNpayClaimRequest),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: claimNpayResponse['data'] = body ? JSON.parse(body) : {};
  return { data, status: res.status, headers: res.headers } as claimNpayResponse;
};

/**
 * @summary 타임냥 광고 시작(토큰 발급)
 */
export type startAdResponse200 = {
  data: StartAd200;
  status: 200;
};

export type startAdResponseSuccess = startAdResponse200 & {
  headers: Headers;
};
export type startAdResponse = startAdResponseSuccess;

export const getStartAdUrl = () => {
  return `/time-nyang/ads/start`;
};

export const startAd = async (
  timeNyangAdStartRequest: TimeNyangAdStartRequest,
  options?: RequestInit,
): Promise<startAdResponse> => {
  const res = await fetch(getStartAdUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(timeNyangAdStartRequest),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: startAdResponse['data'] = body ? JSON.parse(body) : {};
  return { data, status: res.status, headers: res.headers } as startAdResponse;
};

/**
 * @summary 타임냥 광고 완료 처리
 */
export type completeAdResponse200 = {
  data: CompleteAd200;
  status: 200;
};

export type completeAdResponseSuccess = completeAdResponse200 & {
  headers: Headers;
};
export type completeAdResponse = completeAdResponseSuccess;

export const getCompleteAdUrl = () => {
  return `/time-nyang/ads/complete`;
};

export const completeAd = async (
  timeNyangAdCompleteRequest: TimeNyangAdCompleteRequest,
  options?: RequestInit,
): Promise<completeAdResponse> => {
  const res = await fetch(getCompleteAdUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(timeNyangAdCompleteRequest),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: completeAdResponse['data'] = body ? JSON.parse(body) : {};
  return { data, status: res.status, headers: res.headers } as completeAdResponse;
};

/**
 * @summary 타임냥 설정 캐시 리로드
 */
export type reloadConfigResponse200 = {
  data: TimeNyangAdminReloadResponse;
  status: 200;
};

export type reloadConfigResponseSuccess = reloadConfigResponse200 & {
  headers: Headers;
};
export type reloadConfigResponse = reloadConfigResponseSuccess;

export const getReloadConfigUrl = () => {
  return `/time-nyang/admin/config/reload`;
};

export const reloadConfig = async (options?: RequestInit): Promise<reloadConfigResponse> => {
  const res = await fetch(getReloadConfigUrl(), {
    ...options,
    method: 'POST',
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: reloadConfigResponse['data'] = body ? JSON.parse(body) : {};
  return { data, status: res.status, headers: res.headers } as reloadConfigResponse;
};

/**
 * @summary 타임냥 상태 조회
 */
export type stateResponse200 = {
  data: TimeNyangStateResponse;
  status: 200;
};

export type stateResponseSuccess = stateResponse200 & {
  headers: Headers;
};
export type stateResponse = stateResponseSuccess;

export const getStateUrl = () => {
  return `/time-nyang/state`;
};

export const state = async (options?: RequestInit): Promise<stateResponse> => {
  const res = await fetch(getStateUrl(), {
    ...options,
    method: 'GET',
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: stateResponse['data'] = body ? JSON.parse(body) : {};
  return { data, status: res.status, headers: res.headers } as stateResponse;
};
